import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLogout = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M4.395 2C2.52 2 1 3.533 1 5.425v13.15C1 20.467 2.52 22 4.395 22H12c1.875 0 3.395-1.533 3.395-3.425v-2.191c0-.681-.547-1.233-1.222-1.233-.675 0-1.222.552-1.222 1.233v2.191c0 .53-.426.96-.951.96H4.395a.955.955 0 0 1-.95-.96V5.425c0-.53.425-.96.95-.96H12c.525 0 .95.43.95.96v2.191c0 .681.548 1.233 1.223 1.233s1.222-.552 1.222-1.233V5.425C15.395 3.533 13.875 2 12 2H4.395Zm14.988 5.84a1.215 1.215 0 0 0-1.729 0 1.24 1.24 0 0 0 0 1.744l1.173 1.183H6.567c-.674 0-1.221.552-1.221 1.233 0 .68.547 1.233 1.222 1.233h12.259l-1.173 1.183a1.24 1.24 0 0 0 0 1.743 1.215 1.215 0 0 0 1.729 0l3.253-3.28a1.228 1.228 0 0 0 .361-.962 1.234 1.234 0 0 0-.355-.789l-3.26-3.287Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLogout);
export default ForwardRef;
